// extracted by mini-css-extract-plugin
export default {"container":"block-employee_container__fPLVa"};